<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'DhcpSnooping Global Config'" style="height: 100%">
         <div style="margin-left: 10px">
          <input
            type="radio"
            id="dhcpConfigEnable"
            value="1"
            v-model="dhcpSnoopingEn"
          />
          <label for="dhcpConfigEnable">DhcpSnooping Enable</label>
          <input
            type="radio"
            id="dhcpConfigDisable"
            value="0"
            v-model="dhcpSnoopingEn"
          />
          <label for="dhcpConfigDisable">DhcpSnooping Disable</label>
          <button
            type="button"
            class="btn btn-primary"
            @click="setDhcpSnoopingEn()"
          >
            {{ "Apply" }}
          </button>
        </div>
        </block-cntr>
        <block-cntr :btitle="'DhcpSnooping Port Config'" style="height: 100%">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllIndex"
                />
                <label for="idSelectAllIndex"></label>
              </th>
              <th
                v-for="(value, key) in title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in dhcpTable"
              :key="row.index"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectStp' + index"
                  />
                  <label :for="'idRowSelectStp' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.portId }}</div>
              </td>
              <td>
                <div>{{ row.mode }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'DhcpSnooping Config Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="dhcpmode"
                  >Mode</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="dhcpmode"
                    v-model="portDhcpMode"
                  >
                    <option value="0">untrust</option> 
                    <option value="1">trust</option>
                  </select>
               </div>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApplyPort()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import InfoBox from "../components/InfoBox.vue"

export default {
  name: "dhcpsnooping",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      dhcpSnoopingEn: "0",
      iBox: {},
      select: [],
      portDhcpMode:"0",
      dhcpTable: [],
    }
  },

  created() {
    this.loadDhcpInfo()
  },

  methods: {
    loadDhcpInfo() {
      get("dhcpsnoopinfo")
        .then((res) => {
          this.dhcpTable = res.data.data
          this.title    = res.data.title
          this.dhcpSnoopingEn = res.data.dhcpSnoopingEn
          console.log(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      this.portDhcpMode="0"
    },

    clkApplyPort() {
      var newProfile = {}
      var portdata = []

      for (let i = 0; i < this.dhcpTable.length; i++) {
        if (this.dhcpTable[i].selected) {
            portdata.push({ port:  this.dhcpTable[i].portId,
                            mode: Number(this.portDhcpMode)})
        }
      }
      newProfile["portdata"]= portdata

      post("dhcpsnoopportconfig", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
          this.loadDhcpInfo()
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", "Post error!")
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    setDhcpSnoopingEn() {
      var newProfile = {
         enable: Number(this.dhcpSnoopingEn),
      }

      post("dhcpsnoopconfig", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadDhcpInfo()
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", "Post error!")
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },


    clkEdit() {
      for (let i = 0; i < this.dhcpTable.length; i++) {
        if (this.dhcpTable[i].selected) {
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    changeSelectAll() {
      for (let i = 0; i < this.dhcpTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.dhcpTable[i], "selected", true)
        } else {
          this.$set(this.dhcpTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
